<ng-container>
  <form nz-form [formGroup]="simSwapForm" (ngSubmit)="submitForm()">
    <div nz-col>
      {{ getStrPath("FORM_SIM_SWAP.OLD_ICCID") | translate }}
    </div>
    <nz-form-item>
      <nz-form-control>
        <nz-input-group>
          <input type="text" nz-input formControlName="oldIccid" />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <i class="icon-swap" nz-icon nzType="swap"></i>

    <div nz-col>
      {{ getStrPath("FORM_SIM_SWAP.NEW_ICCID") | translate }}
    </div>
    <nz-form-item>
      <nz-form-control [nzErrorTip]="newIccidErrorTpl">
        <nz-input-group>
          <input type="text" nz-input formControlName="newIccid" />
        </nz-input-group>
        <ng-template #newIccidErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            {{
              getStrPath("FORM_SIM_SWAP.ERROR.REQUIRED_NEW_ICCID") | translate
            }}
          </ng-container>
          <ng-container
            *ngIf="
              !control.hasError('required') &&
              (control.hasError('luhnCheck') || control.hasError('minlength'))
            "
          >
            {{ "FORM.ERR.PATTERN_ICCID" | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <nz-form-control>
      <button
        [disabled]="!simSwapForm.valid"
        nz-button
        nzType="default"
        nzBlock
      >
        {{ "BUTTON.CONFIRM" | translate }}
      </button>
    </nz-form-control>
  </form>
</ng-container>
